// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type MoneyBackGuarantee24CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const MoneyBackGuarantee24Circle: FC<MoneyBackGuarantee24CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path
                d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0Zm2.803 22.893-2.708-2.66-1.33 1.33 4.038 4.037 6.697-6.698-1.33-1.377-5.367 5.368ZM8.4 8.5c-.522 0-.97.187-1.341.559A1.83 1.83 0 0 0 6.5 10.4v11.4c0 .522.187.97.559 1.342.372.372.819.558 1.341.558h3.895v-1.9H8.4V10.4h15.2v1.9H8.4v3.8h17.1v-5.7c0-.522-.186-.97-.559-1.341A1.83 1.83 0 0 0 23.6 8.5H8.4Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default MoneyBackGuarantee24Circle;
